export default "__VITE_ASSET__D6Y9bqda__"